module.exports = __webpack_public_path__ + "static/media/position.290cbf38.svg";